export default __webpack_public_path__ + "static/media/iconheader.2264e7aa.svg";